import { toFirstLowerCase } from 'infrastructure/functions';

import { deleteUnnecessaryEmptyLines } from '../helpers';

type TData = {
  deviceThatNeedsTroubleshooting: [];
  reasonForTroubleshooting: [];
  readingTransmission: [];
  bloodPressureMonitor: [];
  glucometer: [];
  weightScale: [];
  pulseOximeter: [];
  peakFlowMeter: [];
  deviceTroubleshootingText: any;
  outcome: null | string;
  deviceTroubleshootingUnsuccessfulText: null | string;
  extraDeviceTroubleshooting: string[];
  whichPerson: string;
  otherPerson: string;
  performedDeviceQC: string[];
  controlSolutionOrdered: string[];
};

const joinArray = (arr: string[]) => arr?.join(', ');

export const generateDeviceTroubleshootingMessage = <T extends TData>(
  data: T,
) => {
  const {
    deviceThatNeedsTroubleshooting,
    reasonForTroubleshooting,
    readingTransmission,
    bloodPressureMonitor,
    glucometer,
    weightScale,
    pulseOximeter,
    peakFlowMeter,
    deviceTroubleshootingText,
    outcome,
    deviceTroubleshootingUnsuccessfulText,
    extraDeviceTroubleshooting,
    whichPerson,
    otherPerson,
    performedDeviceQC,
    controlSolutionOrdered,
  } = data;
  let message = '';
  const isPatient = whichPerson === 'Patient';
  const target =
    whichPerson === 'Other'
      ? toFirstLowerCase(otherPerson as string)
      : toFirstLowerCase(whichPerson as string);

  const speakWith = isPatient ? 'patient' : `${target}`;

  if (deviceThatNeedsTroubleshooting.length > 0) {
    message += `Patient is currently having issues with their ${joinArray(
      deviceThatNeedsTroubleshooting,
    )}. `;
  }
  if (reasonForTroubleshooting.length > 0) {
    message += `MA confirmed reason for device troubleshooting call: ${joinArray(
      reasonForTroubleshooting,
    )}. `;
  }
  if (
    deviceThatNeedsTroubleshooting.length > 0 ||
    reasonForTroubleshooting.length > 0
  ) {
    message += '\n';
    message += '\n';
  }
  if (readingTransmission.length > 0) {
    message += `MA provided general advice to ensure accurate readings. ${joinArray(
      readingTransmission,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (bloodPressureMonitor.length > 0) {
    message += `MA provided education for common user errors when monitoring blood pressure. ${joinArray(
      bloodPressureMonitor,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (glucometer.length > 0) {
    message += `MA provided education for common user errors when monitoring blood sugar. ${joinArray(
      glucometer,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (performedDeviceQC.length > 0) {
    message += `MA assisted ${speakWith} to perform device QC. `;
    message += '\n';
    message += '\n';
  }
  if (controlSolutionOrdered.length > 0) {
    message += `MA ordered control solution for ${speakWith}. `;
    message += '\n';
    message += '\n';
  }
  if (weightScale.length > 0) {
    message += `MA provided education for common user errors when monitoring weight. ${joinArray(
      weightScale,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (pulseOximeter.length > 0) {
    message += `MA provided education for common user errors when monitoring pulse oximetry. ${joinArray(
      pulseOximeter,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (peakFlowMeter.length > 0) {
    message += `MA provided education for common user errors when monitoring peak flow. ${joinArray(
      peakFlowMeter,
    )}. `;
    message += '\n';
    message += '\n';
  }
  if (deviceTroubleshootingText) {
    message += `MA performed device troubleshooting. ${deviceTroubleshootingText} `;
    message += '\n';
  }

  if (outcome === 'success') {
    message += `Device troubleshooting successful.  Confirmed with reading done on phone. `;
  }
  if (outcome === 'unsuccess') {
    message += `Device troubleshooting unsuccessful due to ${deviceTroubleshootingUnsuccessfulText}. `;
  }
  if (
    extraDeviceTroubleshooting.includes(
      'Address confirmed and Tellichecker ticket submitted',
    )
  ) {
    if (deviceTroubleshootingText || outcome) {
      message += '\n';
      message += '\n';
    }
    message += `MA confirmed address, Tellichecker ticket in progress. `;
  }
  if (extraDeviceTroubleshooting.includes('Device replacement ordered')) {
    if (deviceTroubleshootingText || outcome) {
      message += '\n';
      message += '\n';
    }
    message += `Replacement ordered. `;
  }

  message = deleteUnnecessaryEmptyLines(message);
  return message;
};
